<template src="./index.html"></template>
<style lang="scss" src="./index.scss" scoped></style>
<script>
import { Dialog , PullRefresh, Toast, NoticeBar, Popup } from "vant";
import { mapState } from 'vuex';
import { URL5 } from "@/utils/Redirect";
const ChannelsMap = {
  duanxin: '短信',
  weixin: '微信',
  wangwang: '旺旺',
}
export default {
  components:{PullRefresh, NoticeBar, Popup},
  name: "ChatRoom",
  data() {
    return {
      LOADINGDONE: false,
      isLoading: false,
      SelectIcon: "wangwang",
      ShowChannels: false,
      ShowLabelBox: false,
      ShowUserInfo: true,
      TypeLabelList: ["上新", "折扣", "促销", "优惠"],
      TypeLabelListActive: "",
      MessageLabelList: ["模板一", "模板二", "模板三"],
      MessageLabelListActive: "",
      ww_nick:'',
      offset: 1,
      buyer_openuid:'',
      ROLE_NAME_IMG: {
        "客服":this.$OSS+"ChatRoom_kefu.png",
        "运营":this.$OSS+"ChatRoom_yunying.png",
        "仓库":this.$OSS+"ChatRoom_cangku.png",
        "其他":this.$OSS+"ChatRoom_qita.png",
      },
      noRootShow: true,
      popup_show: null, //微信打开的遮罩
      popup_img: "", //遮罩的图片
      contentShow: false
    };
  },
  computed:{
    ...mapState({
      getMessageDetail:(state)=>{
        return state.CustomerMessage.getMessageDetail
      },
    })
  },
  created(){
    if(this.$route.query.ww_nick){
      this.ww_nick = this.$route.query.ww_nick
      this.buyer_openuid = this.$route.query.buyer_openuid
      this.GetData({ww_nick:this.ww_nick,offset:this.offset,buyer_openuid:this.buyer_openuid})
    }else{ // 无参数的情况下跳转回消息列表
      this.$router.push({ path:'CustomerMessage'})
    }
  },
  beforeDestroy(){
    this.LOADINGDONE = false
  },
  methods: {
    TypeLabelListChange(item){
      this.TypeLabelListActive = item
    },
    MessageLabelListChange(item){
      this.MessageLabelListActive = item
    },
    onRefresh() {
      this.GetData({offset: this.offset,ww_nick:this.ww_nick,buyer_openuid:this.buyer_openuid})
    },
    GetData(params){
      this.$store.dispatch('CustomerMessage/getMessageDetail',params).then(res=>{
        this.contentShow = true
        if(res.code==1000 && res.data.list.length!=0){
          this.offset ++
          
        }else if(res.code==1000 && res.data.list.length==0 && this.offset!=1){
          Toast("没有更多数据了")
        }
        if(this.LOADINGDONE === false){ // 进入页面自动定位到最下方
          this.LOADINGDONE = true
          setTimeout(()=>{
            document.getElementById('ChatBox').scrollTo(0, 999999)
          },100)
        }
        this.isLoading = false
      })
    },
    ShowSelectChannelsFn() {
      this.ShowChannels = true;
    },
    HideSelectChannelsFn(key) {
      this.SelectIcon = key;
      this.ShowChannels = false;
      if(key == 'wangwang') {
        this.ShowLabelBox = false;
      }
      this.$store.dispatch('Public/inH5Record',{btn_name: '选择渠道'+key,})
    },
    ShowLabelBoxFn() {
      this.$store.dispatch('Public/inH5Record',{btn_name: ChannelsMap[this.SelectIcon]+'输入框',})
      this.ShowUserInfo = false;
      this.ShowLabelBox = true;
    },
    HideOtherBox() {
      this.ShowUserInfo = !this.ShowUserInfo
      this.ShowLabelBox = false
    },
    closeShowLabe() {
      this.ShowLabelBox = false
    },
    AddChannels() {
      this.$store.dispatch('Public/inH5Record',{btn_name:'添加渠道按钮'})
      this.ShowDialog("该功能正在开发\n敬请期待");
    },
    FocusInput(){
      this.$store.dispatch('Public/inH5Record',{btn_name: ChannelsMap[this.SelectIcon]+'输入框'})
    },
    BlurInput() {
    },
    async SendButton(type) {
      this.$store.commit('Public/SHOW_LOADING',{data:true})
      let res = await this.$store.dispatch('Public/inH5Record',{btn_name: ChannelsMap[this.SelectIcon]+'发送按钮'})
      if (type) {
        this.ShowDialog("该功能正在开发中\n请耐心等待");
      } else {
         let nick= await this.$store.dispatch('Public/getBuyerNick_APP',{buyer_openuid:this.buyer_openuid})
        window.location.href = encodeURI("https://air.1688.com/app/mobile-group/chat-universal-page/pages/index/index.html?targetId=" +nick.data.ww_nick);
      }
    },
    ShowDialog(text) {
      Dialog.alert({
        title: "",
        message: text,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "关闭",
        width: "80vw",
        className: "CustomerWarnTan",
      }).catch(() => {});
    },
    jump_router() {

      if (this.$config.WebOS == "wx") {
        this.popup_show = true;
        if (!window.location.hash.includes("jump_link=1")) {
          history.replaceState({}, 0, window.location.href + "?jump_link=1");
        }
        if (this.$config.SystemOS == "IOS") {
          this.popup_img = this.$OSS + "renew_tips_ios.png";
        } else {
          this.popup_img = this.$OSS + "renew_tips_android.png";
        }
      } else {
        window.open(URL5);
      }
    },
    popup_close() {
      if (window.location.hash.includes("jump_link=1")) {
        history.replaceState(
          {},
          0,
          window.location.href.replace("?jump_link=1", "")
        );
      }
    },
    jump_customer() {
      if(this.$route.query.is_in_list == '0') {
        this.$store.dispatch('Public/inH5Record',{btn_name:'客户头像点击'})
        Toast('该客户数据正在更新中，暂时无法进入客户信息页')
      }else{
        this.$store.dispatch('Public/inH5Record',{btn_name:'客户头像点击'}).then((res)=>{
          this.$router.push({ path:'CustomerInfo', query: {source:'1', ww_nick: this.ww_nick}})
        })
        
      }
    }

  },
};
</script>